// extracted by mini-css-extract-plugin
export var readonly = "_gq-1";
export var star = "_gq-0";